<div class="country-selector">
  <div class="country-selector__title">{{ 'common.selectCountry' | translate }}</div>
  <div class="country-selector__intl-input">
    <input
      class="country-selector__intl-input__country-input"
      type="text"
      id="country-selector"
      #countrySelector
      autocomplete="off"
      aria-label="Select or enter a country"
    />
  </div>

  <frodo-select
    class="country-selector__select-wrapper"
    [(ngModel)]="selectedCountry"
    (selectionChange)="onCountryChange($event)"
  >
    <div frodo-select-value class="country-selector__select-wrapper__select__container">
      <span class="country-selector__select-wrapper__select__container__dial-code">
        {{ formatDialCode(selectedCountryData?.dialCode) }}
      </span>
      <div class="iti__flag iti__{{ selectedCountryData?.iso2 | lowercase }}"></div>
      <div class="country-selector__select-wrapper__select__container__country-name">
        {{ selectedCountryData?.name }}
      </div>
    </div>

    <frodo-select-option
      [value]="country.iso2"
      *ngFor="let country of countries; trackBy: trackByIso2"
    >
      <div class="country-selector__select-wrapper__select__container">
        <div class="country-selector__select-wrapper__select__container__dial-code">
          {{ formatDialCode(country.dialCode) }}
        </div>
        <div class="iti__flag iti__{{ country.iso2 | lowercase }}"></div>
        <div class="country-selector__select-wrapper__select__container__country-name">
          {{ country.name }}
        </div>
      </div>
    </frodo-select-option>
  </frodo-select>
</div>
